export default __webpack_public_path__ + "static/media/Ritualistic Armguards.b48f7acf.jpg";